import { PPSCardMembershipRequestClient, PutujmoSite } from '../../swagger/putujmoAdminService';

export const getAllPPSCardMembershipRequestsAction = (putujmoSite: PutujmoSite) => {
  const client = new PPSCardMembershipRequestClient();
	return client.getAll(putujmoSite);
};

export const markPPSCardMembershipRequestPaidAction = (id: number) => {
	const client = new PPSCardMembershipRequestClient();
	return client.markPaid(id);
};

export const deletePPSCardMembershipRequestAction = (id: number) => {
	const client = new PPSCardMembershipRequestClient();
	return client.remove(id);
};
